<template>
    <section v-if="failure" class="ai-failure" :class="{ 'ai-failure--notice': !blocking }" role="alert">
        <span class="ai-failure__icon"><i :class="icon" aria-hidden="true"></i></span>
        <div>
            <strong>{{ title }}</strong>
            <p>{{ description }}</p>
            <button v-if="failure.retryable" type="button" :disabled="retrying" @click="$emit('retry')">
                <i class="bi-arrow-clockwise" aria-hidden="true"></i>
                {{ retrying ? 'Executando…' : retryLabel }}
            </button>
        </div>
    </section>
</template>

<script>
const REVIEW_DEFERRED = 'cycle_budget_insufficient'
const REVIEW_BLOCKED = 'critical_review_blocked'

export default {
    name: 'AssistantFailureCard',
    emits: ['retry'],
    props: {
        failure: { type: Object, default: null },
        retrying: Boolean,
    },
    computed: {
        code() {
            return this.failure?.technical_code || ''
        },
        // Sem draft publicado o ciclo realmente falhou; com draft, o formulário
        // já está utilizável e o card é apenas um aviso sobre a revisão.
        blocking() {
            return !this.failure?.draft_available
        },
        icon() {
            return this.blocking ? 'bi-exclamation-triangle' : 'bi-info-circle'
        },
        title() {
            if (this.blocking) return 'Não consegui montar uma proposta válida.'
            if (this.code === REVIEW_DEFERRED) return 'Proposta estruturada — revisão pendente.'
            if (this.code === REVIEW_BLOCKED) return 'Proposta estruturada — revisão não aprovada.'
            return 'Proposta estruturada — revisão interrompida.'
        },
        description() {
            if (this.blocking) {
                return `Falha durante ${this.failure?.stage_label || 'o processamento'}. O último draft válido foi mantido.`
            }
            if (this.code === REVIEW_DEFERRED) {
                return 'A revisão de qualidade não chegou a ser executada por falta de tempo no ciclo. O draft está no formulário.'
            }
            if (this.code === REVIEW_BLOCKED) {
                return 'A revisão apontou pontos que impedem a confirmação. O draft está no formulário para ajuste.'
            }
            return 'A revisão de qualidade não pôde ser concluída. O draft está no formulário.'
        },
        retryLabel() {
            if (this.code === REVIEW_DEFERRED) return 'Executar revisão'
            if (this.code === REVIEW_BLOCKED) return 'Revisar novamente'
            return 'Tentar novamente'
        },
    },
}
</script>

<style scoped>
.ai-failure { display: flex; gap: 0.7rem; margin: 0.7rem 1rem 0; padding: 0.85rem; border: 1px solid #fecdca; border-radius: 14px; background: #fff6f5; color: #7a271a; }
.ai-failure__icon { display: grid; flex: 0 0 2rem; width: 2rem; height: 2rem; place-items: center; border-radius: 10px; background: #fee4e2; color: #d92d20; }
.ai-failure div { min-width: 0; }
.ai-failure strong { font-size: 0.78rem; }
.ai-failure p { margin: 0.25rem 0 0.5rem; font-size: 0.72rem; line-height: 1.4; }
.ai-failure button { display: inline-flex; gap: 0.35rem; align-items: center; padding: 0.45rem 0.65rem; border: 0; border-radius: 9px; background: #b42318; color: #fff; font-size: 0.7rem; font-weight: 700; cursor: pointer; }
.ai-failure button:disabled { cursor: default; opacity: 0.55; }
.ai-failure--notice { border-color: #fde4b8; background: #fffaf0; color: #7a4a09; }
.ai-failure--notice .ai-failure__icon { background: #fdeccd; color: #b54708; }
.ai-failure--notice button { background: #b54708; }
</style>
